import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFileAlt,
  FaShoppingCart,
  FaChartLine,
  FaUndo,
} from "react-icons/fa";
import "./viewdata.css";

const reportCards = [
  {
    path: "/mis-pdf",
    category: "PURCHASING",
    title: "View Purchase MIS Data",
    description: "Open the purchase MIS report and review its records.",
    Icon: FaFileAlt,
  },
  {
    path: "/Reorder",
    category: "INVENTORY",
    title: "Re-Order Data",
    description: "Review inventory records available in the re-order report.",
    Icon: FaShoppingCart,
  },
  {
    path: "/SalesReturn",
    category: "SALES",
    title: "Sales Report",
    description: "Open the sales report and review sales activity.",
    Icon: FaChartLine,
  },
  {
    path: "/ReturnSales",
    category: "RETURNS",
    title: "Sales Return Report",
    description: "Review sales return records in their dedicated report.",
    Icon: FaUndo,
  },
];

function Viewdata() {
  const navigate = useNavigate();

  return (
    <div className="viewdata-wrapper">
      <main className="viewdata-container">
        <header className="viewdata-hero">
          <div className="viewdata-hero-copy">
            <span className="viewdata-eyebrow">REPORTS / OPERATIONS</span>
            <h1 className="viewdata-dashboard-title">MIS Dashboard</h1>
            <p>
              Access purchase, inventory, sales, and return reports from one
              workspace.
            </p>
          </div>

          <div className="viewdata-hero-summary" aria-label="Four reports available">
            <span className="viewdata-summary-icon" aria-hidden="true">
              <FaFileAlt />
            </span>
            <span className="viewdata-summary-copy">
              <strong>4 reports</strong>
              <span>Available to open</span>
            </span>
          </div>
        </header>

        <section className="viewdata-library" aria-labelledby="viewdata-library-title">
          <div className="viewdata-section-heading">
            <div>
              <span className="viewdata-section-kicker">REPORT LIBRARY</span>
              <h2 id="viewdata-library-title">Choose a report</h2>
              <p>Select a report to open its existing data view.</p>
            </div>
            <span className="viewdata-destination-count">4 destinations</span>
          </div>

          <div className="viewdata-card-container">
            {reportCards.map(({ path, category, title, description, Icon }) => (
              <button
                key={path}
                type="button"
                className="viewdata-dashboard-card"
                onClick={() => navigate(path)}
              >
                <span className="viewdata-card-icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="viewdata-card-content">
                  <span className="viewdata-card-category">{category}</span>
                  <span className="viewdata-card-title">{title}</span>
                  <span className="viewdata-card-description">
                    {description}
                  </span>
                </span>
                <span className="viewdata-card-arrow" aria-hidden="true">
                  →
                </span>
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Viewdata;
